export default {
    meta: {
        title: '内部档期占用',
        isShowNav: true,
    },
};
